import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'

const ConfirmButton = ({ label, callback }) => {
  const [confirm, setConfirm] = useState(false)

  const handleSubmit = () => {
    callback()
    setConfirm(false)
  }

  return (
    <div className="flex my-1">
      {!confirm && (
        <button
          onClick={() => setConfirm(!confirm)}
          aria-label="Resend Notification"
          className="button-fill w-full max-w-xs h-14"
        >
          <h5 className="font-bold">{label}</h5>
        </button>
      )}
      {confirm && (
        <div className="button-outline w-full max-w-xs h-14">
          <div className="flex gap-2 justify-center items-center h-full">
            <h5 className="font-bold">Confirm</h5>
            <button
              onClick={handleSubmit}
              aria-label="Confirm"
              className="button-confirm rounded-full py-0.5 px-1"
            >
              <FontAwesomeIcon icon={faCheck} className="w-4 h-4" />
            </button>
            <button
              onClick={() => setConfirm(false)}
              aria-label="Cancel"
              className="button-cancel rounded-full py-0.5 px-1"
            >
              <FontAwesomeIcon icon={faTimes} className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default ConfirmButton
